import {
  IoChatboxEllipsesOutline,
  IoSpeedometerOutline
} from "react-icons/io5"
import Logo from "../assets/image/LogoAJB.png"
import { PermintaanPerubahaDataDetail, PermintaanPerubahaDataList } from "pages/Support/PermintaanPerubahanData"

const generateSpecialHAK = (prefix) => {
  const moduleAlias = [
    "PRY",
    "ASM",
    "TNK",
    "SIA",
    "ANG",
    "CRM",
    "PRO",
    "PRD",
    "SLS",
    "COC",
    "INV",
    "MKT",
  ]

  if (prefix) {
    return moduleAlias.map((modul) => `${prefix}${modul}`)
  }

  return []
}

export default {
  LOGO: Logo,
  MODUL: "Request Management ",

  /* 
    MENU REQUIREMENTS
      > TEXT  = REQUIRED,
      > LINK  = REQUIRED,
      > EXACT = OPTIONAL (TRUE/FALSE),
      > TYPE  = REQUIRED (MENU/DROPDOWN)
      > HAK   = REQUIRED (HARUS BERBENTUK ARRAY)
      > LOGO  = OPTIONAL 
  */

  MENU: [
    {
      text: "Dashboard",
      link: "/",
      type: "menu",
      exact: true,
      icon: <IoSpeedometerOutline />,
      hak: [
        "HRDU",
        "ASM",
        "MKT",
        "CRM",
        "INV",
        "ANG",
        "HRDA",
      ]
        .concat([
          generateSpecialHAK("HRDU_APR_REGPC"),
          generateSpecialHAK("HRDU_APR_REGPNPC"),
          generateSpecialHAK("HRDU_APR_REGRPC"),
        ])
        .flat(),
    },
    {
      text: "Support",
      type: "dropdown",
      icon: <IoChatboxEllipsesOutline />,
      hak: ["HRDU", "ASM", "MKT", "CRM", "INV", "ANG", "HRDA"],
      menu: [
        {
          text: "Permintaan Pengubahan Data",
          link: "/rqm/support/permintaan-pengubahan-data",
          hak: [
            "HRDU",
            "ASM",
            "MKT",
            "CRM",
            "INV",
            "ANG",
            "HRDA",
          ],
        }
      ]

    },
  ],

  ROUTES: [
    {
      exact: true,
      route: "/rqm/support/permintaan-pengubahan-data",
      hak: ["HRDU", "HRDU_APR_REGAPPHP"],
      page: PermintaanPerubahaDataList
    },
    {
      exact: true,
      route: "/rqm/support/permintaan-pengubahan-data/detail/:id_permintaan_perubahan_data_master",
      hak: ["SUPA", "HRDU", "HRDU_APR_REGAPPHP"],
      page: PermintaanPerubahaDataDetail
    },
  ],
}
